module.exports = __webpack_public_path__ + "static/media/stamp.aa606d1f.png";